<template>
  <div>
    <app-notification :title="'השירות הוקפא והתזרים הפסיק להתעדכן.'"
                      :text="'כדי שנמשיך לבנות תזרים חודשי ולשלוח עדכונים צריך לעדכן את פרטי התשלום.'"
                      :notification-buttons="[
                        {
                          title:'לעדכון פרטי תשלום',
                          variant: 'primary',
                          action: updatePayment,
                        },
                      ]"
                      :icon-type="'danger'"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';
import router from '../../../../../../../router';
import { SUBSCRIPTION_STATES } from '../../../../../../../constants/subscription-state';
import DDLogs from '../../../../../../../DDLogs';

export default {
  name: 'DormantNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('DormantNotification', { subscriptionState: this.subscriptionState });
  },
  computed: {
    ...mapState('subscriptionState', ['subscriptionState']),
  },
  methods: {
    openSubscriptionPage() {
      Segment.trackUserInteraction('OpenSubscriptionPageClicked');
      router.push({ path: '/subscription' });
    },
    gotoAccountSettings() {
      router.push({ path: '/account-settings' });
    },
    updatePayment() {
      switch (this.subscriptionState) {
        case SUBSCRIPTION_STATES.DORMANT_AFTER_CANCELED:
          this.gotoAccountSettings();
          break;
        case SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL:
          this.openSubscriptionPage();
          break;
        default: DDLogs.error(`Unexpected subscription state in dormant notification: ${this.subscriptionState}`);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
</style>
